import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import { queryClient } from "@/config/react-query.config";
import { useAppTheme } from "@/hooks";
import { appTheme } from "@/styles/app-theme";

export const Providers = ({ children }: { children: ReactNode }) => {
  const { isDarkMode } = useAppTheme();

  return (
    <HelmetProvider>
      <ThemeProvider theme={appTheme[isDarkMode ? "dark" : "light"]}>
        <QueryClientProvider client={queryClient}>
            {children}
            <Toaster
              richColors
              position="bottom-right"
              duration={3000}
              offset={64}
            />
        </QueryClientProvider>
        <CssBaseline />
      </ThemeProvider>
    </HelmetProvider>
  );
};
